import { MarketingNav } from '@/components/marketing/marketing-nav';
import { MarketingFooter } from '@/components/marketing/marketing-footer';
import { FloatingBookCall } from '@/components/marketing/floating-book-call';
import { useSmoothScroll } from '@/components/marketing/use-smooth-scroll';

/** Warm page wrapper: nav, footer, floating "Book a call" and smooth scrolling. */
export function MarketingShell({ children }: { children: React.ReactNode }) {
  useSmoothScroll();
  return (
    <div className="warm-page min-h-screen">
      <MarketingNav />
      <main>{children}</main>
      <MarketingFooter />
      <FloatingBookCall />
    </div>
  );
}
